export default __webpack_public_path__ + "static/media/regata.897b945b.png";